import { SplashBrokenBank } from "./views/SplashBrokenBank";
import { SplashTotalWin } from "./views/SplashTotalWin";
import { SplashViewFreeSpins } from "./views/SplashViewFreeSpins";

export class SplashWindows {

    static CAP_WINDOW:SplashBrokenBank; 
    static FREESPIN:SplashViewFreeSpins; 
    static OUTRO:SplashTotalWin; 

    constructor(){
        SplashWindows.CAP_WINDOW = new SplashBrokenBank();
        SplashWindows.FREESPIN = new SplashViewFreeSpins();
        SplashWindows.OUTRO = new SplashTotalWin();
    }

    create<T>(c: { new(): T; }): T {
        return new c();
    }
}